import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'environments/environment';



@Injectable()
export class CalendarService {
  protected url: string = environment.iCBMSWebApi.url + "/calendar";

  constructor(private http: HttpClient) { }

  getFirstMonths() {
    return this.http.get(`${this.url}/first/months/list`);
  }
}